import { api } from "@/api";

const { setAccessToken } = useAuth();

type RequestAccessTokenResponse = {
  accessToken: string;
};

// The dashboard fans out several authenticated requests at once, so an expired
// access token would otherwise trigger one refresh per in-flight request. Share
// a single in-flight refresh so they all wait on the same rotated token.
let inFlightRefresh: Promise<RequestAccessTokenResponse> | null = null;

// The refresh token travels as an httpOnly cookie scoped to this route; the
// API reads it and sets the rotated one.
export const refreshAccessToken = async () => {
  if (inFlightRefresh) return inFlightRefresh;

  inFlightRefresh = (async () => {
    try {
      const { body } = await api.post<RequestAccessTokenResponse>(
        "/auth/refresh-token/",
        {
          authenticated: false,
          credentials: "same-origin",
        },
      );

      setAccessToken(body.accessToken);

      return body;
    } finally {
      inFlightRefresh = null;
    }
  })();

  return inFlightRefresh;
};
